import { render, staticRenderFns } from "./SlidingTabsTitle.vue?vue&type=template&id=504bab1d&scoped=true"
import script from "./SlidingTabsTitle.vue?vue&type=script&lang=js"
export * from "./SlidingTabsTitle.vue?vue&type=script&lang=js"
import style0 from "./SlidingTabsTitle.vue?vue&type=style&index=0&id=504bab1d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504bab1d",
  null
  
)

export default component.exports